import { useEffect, useMemo, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { images } from "../../constants/images";
import { navOptions } from "../../constants/navigation";
import styles from "./navBar.module.scss";
import Notifications from "../../containers/Notifications/NotificationsContainer";
import { NavBarProps } from "../../interfaces/components";
import Dropdown from "../Dropdown";
import { IconButton } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useToast } from "../../helpers/hooks";
import { FaRegBell, FaBell } from 'react-icons/fa';
import { useWindowSize } from "use-hooks";
import Badge from '@mui/material-next/Badge';
import SellDropdown from './SellDropdown';
import SellDropdownBrand from './SellDropdownBrand';
import PublishVehicleModal from '../PublishVehicleModal/PublishVehicleModal';
import BulkUploadModal from '../BulkUploadModal/BulkUploadModal';


const NavBar = ({
    user,
    notifications,
    concessionary,
    cleanConcessionary,
    branch,
    cleanBranch,
    setPublicationForNews,
    cleanVariants,
    setDataSheet,
    adminBrand,
    getAdminBrand,
    massiveCharge,
    downloadUsedVehicleTemplate,
    downloadNewVehicleTemplate,
    bulkUploadVehicles,
    bulkUploadImages,
    validateUploadStatus,
    cleanMassiveCharge,
    bulkUploadImagesStorage,
    confirmUploadProcess
}: NavBarProps) => {
    const toast = useToast();
    const navigate = useNavigate();
    const windowSize = useWindowSize();
    const [openMenu, setOpenMenu] = useState(false);
    const [openSell, setOpenSell] = useState(false);
    const [openNotifications, setOpenNotifications] = useState(false);
    const [showPublishModal, setShowPublishModal] = useState(false);
    const [showBulkUploadModal, setShowBulkUploadModal] = useState(false);
    const [selectedVehicleType, setSelectedVehicleType] = useState<'new' | 'used' | null>(null);
    const [selectedPublicationMethod, setSelectedPublicationMethod] = useState<'manual' | 'massive' | null>(null);
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const [fileError, setFileError] = useState<string>('');
    const [lineCount, setLineCount] = useState<number | null>(null);
    const [showImagesModal, setShowImagesModal] = useState(false);
    const [isUploading, setIsUploading] = useState(false);

    const handleClosePublishModal = () => {
        setShowPublishModal(false);
        setSelectedVehicleType(null);
    };
    
    const handleCloseBulkUploadModal = () => {
        setShowBulkUploadModal(false);
        setShowPublishModal(true);
        
    };
    
    const handleCloseAllModals = () => {
        setShowBulkUploadModal(false);
        setShowPublishModal(false);
        setSelectedVehicleType(null);
        setSelectedPublicationMethod(null);
        setSelectedFile(null);
        setFileError('');
        setShowImagesModal(false);
        setIsUploading(false);
    };


    const isBrandView = user?.profile?.code === "admin-brand";

    const getBrandName = () => {
        if (!isBrandView) return "";

        if (adminBrand?.fetching === "loading") return "...";
        if (adminBrand?.fetching === "failure") return "Error al cargar marca";

        if (adminBrand?.data?.brands && adminBrand.data.brands.length > 0) {

            const userBrand = adminBrand.data.brands.find((brand: any) =>
                brand._id === user?.brand || brand.brand_id === user?.brand
            );
            return userBrand ? userBrand.name : adminBrand.data.brands[0].name;
        }

        return "Cargando...";
    };
    const loadingOptions = useMemo(() => {
        let loading = true;
        if (user?.profile?.code && user?.profile.code !== "admin-dealership") {
            loading = false;
        }
        else if (user?.profile.code === "admin-dealership" && !concessionary?.data?.type) {
            loading = true;
        }
        else if (user?.profile.code === "admin-dealership" && concessionary?.data?.type) {
            loading = false;
        }
        return loading;
    }, [user, concessionary])

    const onPressSell = () => {
        cleanVariants();
        setDataSheet([]);
        setPublicationForNews(null);
        navigate('/sell');
    };

    const handleOptionClick = (path: string) => {
        navigate(path);
        window.location.reload();
    };


    useEffect(() => {
        if (user?.profile?.code === "admin-brand" && adminBrand?.fetching === "unknown") {
            getAdminBrand();
        }
    }, [user, adminBrand?.fetching, getAdminBrand]);

    // useEffect(() => {
    //     if(concessionary?.fetching === "failure"){
    //         toast("Ha ocurrido un error al buscar su concesionaria");
    //     }
    //     cleanConcessionary();
    // }, [concessionary?.fetching]);

    // useEffect(() => {
    //     if(branch?.fetching === "failure"){
    //         toast("Ha ocurrido un error al buscar su sucursal");
    //     }
    //     cleanBranch();
    // }, [branch?.fetching]);

    return (
        <div className={styles.navBarContainer}>
            <NavLink className={styles.linzeLink} to={
                user?.profile?.code === "admin-brand"
                    ? "/profile/dashboard"
                    : concessionary?.data?.type === "new"
                        ? "/profile/my_publications"
                        : "/profile/dashboard"
            }>
                <img src={images.NewLogoB2C} className={styles.logo} alt="Logo" />
            </NavLink>
            <IconButton className={styles.menu} onClick={() => setOpenMenu(true)}>
                <MenuIcon className={styles.icon} />
            </IconButton>
            <div id="navBarOptions" className={`${styles.navBarLabels} ${concessionary?.data?.type === "new" && styles.navBarNews} ${openMenu && styles.open}`}>
                {
                    (user && !loadingOptions) ?
                        <div className={`${styles.region} ${concessionary?.data?.type === "new" && styles.newsDealership}`} onClick={() => navigate('/profile')}>
                            <p className={styles.dealership}>
                                <span className={styles.label}>
                                    {isBrandView ? "Marca:" : "Concesionaria:"}
                                </span>
                                <span>
                                    {isBrandView
                                        ? getBrandName()
                                        : (concessionary?.fetching === "loading" ? "..." : concessionary?.data?.name)
                                    }
                                </span>
                            </p>
                            {
                                user?.profile?.code !== "admin-dealership" && user?.profile?.code !== "admin-brand" &&
                                <p className={styles.branch}>
                                    <span className={styles.label}>Sucursal:</span>
                                    <span>{branch?.fetching === "loading" ? "..." : branch?.data?.name}</span>
                                </p>
                            }
                        </div>
                        : null
                }
                {
                    loadingOptions ? null : navOptions.map((option: any, index: number) => {
                        if ((option.to === "/" && user)) return;
                        if (((option.to === "/profile" || option.to === "/notifications") && !user)) return;
                        if (option.to === "/sell") {

                            if (user?.profile?.code === "admin-brand") {
                                return (
                                    <SellDropdownBrand
                                        key={option.id}
                                        className={concessionary?.data?.type === "new" ? styles.sellNews : ""}
                                    />
                                )
                            } else {
                                return (
                                    <button className={styles.sellButton} onClick={() => setShowPublishModal(true)}>
                                        <span>Publica tus autos</span>
                                    </button>
                                )
                            }
                        }
                        if (option.to === "/notifications" && windowSize.width > 1024) {
                            let unreaded = 0;
                            return (
                                <div className={styles.notifications} key={index}>
                                    {
                                        notifications && notifications.forEach((item: any) => unreaded = (!item?.read) ? unreaded + 1 : unreaded)
                                    }
                                    {
                                        unreaded > 0 &&
                                        <Badge
                                            badgeContent={unreaded}
                                            color="error"
                                            classes={{
                                                root: styles.unReaded,
                                                badge: styles.badge
                                            }}
                                        />
                                    }
                                    <Dropdown
                                        type="icon"
                                        icon={openNotifications ? <FaBell className={styles.notificationsIcon} /> : <FaRegBell className={styles.notificationsIcon} />}
                                        onPress={() => setOpenNotifications(!openNotifications)}
                                        className={styles.dropdown}
                                        id={`link-${option.id}`}
                                    >
                                        <Notifications />
                                    </Dropdown>
                                </div>
                            )
                        }
                        if (option.to) {
                            return (
                                <NavLink
                                    key={option.title}
                                    className={`
                                    ${styles.link}
                                    ${({ isActive }: any) => isActive ? styles.activeLink : undefined}
                                `}
                                    id={`link-${option.id}`}
                                    to={option.to}
                                    title={option?.title}
                                >
                                    {option.title}
                                </NavLink>
                            )
                        }
                    })
                }
            </div>
            <div className={`${styles.bkgr} ${openMenu && styles.open}`} onClick={() => setOpenMenu(false)}></div>

            {/* Publish Vehicle Modal */}
            <PublishVehicleModal
                isOpen={showPublishModal}
                onClose={handleClosePublishModal}
                selectedVehicleType={selectedVehicleType}
                selectedPublicationMethod={selectedPublicationMethod}
                setSelectedVehicleType={setSelectedVehicleType}
                setSelectedPublicationMethod={setSelectedPublicationMethod}
                onContinue={(vehicleType, publicationMethod) => {
                    setShowPublishModal(false);
                    cleanVariants();
                    setDataSheet([]);
                    setPublicationForNews(null);

                    if (publicationMethod === 'manual') {
                        if (vehicleType === 'used') {
                            handleOptionClick('/sell/used-car');
                        }
                        if (vehicleType === 'new') {
                            handleOptionClick('/sell/new-car');
                        }
                    } else {
                        // Show bulk upload modal instead of redirecting
                        setSelectedVehicleType(vehicleType);
                        setShowBulkUploadModal(true);
                    }
                }}
            />
            
            <BulkUploadModal 
                isOpen={showBulkUploadModal}
                onClose={handleCloseBulkUploadModal}
                onCloseAll={handleCloseAllModals}
                bulkUploadImagesStorage={bulkUploadImagesStorage}
                vehicleType={selectedVehicleType || 'used'}
                selectedPublicationMethod={selectedPublicationMethod}
                massiveCharge={massiveCharge}
                confirmUploadProcess={confirmUploadProcess}
                downloadUsedVehicleTemplate={downloadUsedVehicleTemplate}
                downloadNewVehicleTemplate={downloadNewVehicleTemplate}
                bulkUploadVehicles={bulkUploadVehicles}
                bulkUploadImages={bulkUploadImages}
                validateUploadStatus={validateUploadStatus}
                cleanMassiveCharge={cleanMassiveCharge}
                onUploadComplete={(file) => {
                    setShowBulkUploadModal(false);
                    toast(`Importación de vehículos completada exitosamente`);
                }}
                selectedFile={selectedFile}
                setSelectedFile={setSelectedFile}
                fileError={fileError}
                setFileError={setFileError}
                lineCount={lineCount}
                setLineCount={setLineCount}
                showImagesModal={showImagesModal}
                setShowImagesModal={setShowImagesModal}
                isUploading={isUploading}
                setIsUploading={setIsUploading}
            />
        </div>
    )
}
export default NavBar;